import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { AuthService } from '../../services/auth/auth.service';
import { ClienteService } from '../../services/cliente/cliente.service';
import { ClienteModel } from '../../models/cliente/cliente.model';
import { Router } from '@angular/router';
import { SocketConnectionService } from '../../services/socketConnection/socket-connection.service';
import { SucursalService } from '../../services/sucursal/sucursal.service';
import { UserModel } from '../../models/auth/user.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {

  public elem: any;
  public dark: boolean = this.layout.config.settings.layout_version == 'dark-only' ? true : false;
  public admin: boolean = false;
  public path: string = "/";
  public viewIcon:boolean = true; 

  //MV CAT-104 Variable para almacenar rol del usuario
  public rol: number = this.authServices.usuario.id_rol_usr_web;

  // MC CATFER-92 Variable para almacenar el cliente actual
  public nombreCliente: string = '';
  
  constructor(public layout: LayoutService,
    public authService: AuthService,
    public navServices: NavService, 
    @Inject(DOCUMENT) private document: any,
    private authServices: AuthService,
    private clienteService: ClienteService,
    private router: Router,
    private socketConn : SocketConnectionService,
    private sucursalService: SucursalService
  ) {
  }

  ngOnInit() {
    this.elem = document.documentElement;
    this.admin = this.authServices.usuario.admin;
    if(this.admin){
      this.path = "/configuracion/home";
      // console.log(this.path);
    }

    // MC CATFER-92 Obtengo el cliente
    if (!this.admin) {
      this.obtenerCliente(this.authServices.usuario.id_cliente);
    }
  }

  ngAfterViewInit(): void {
    // MC CATFER-117 Se inicia la conexión con Ably solo fuera de la configuracion
    if (this.router.url.split('/')[1] !== 'configuracion') {
      if (!this.socketConn.isConnected()){
        this.socketConn.InicializarConnection();
      }

      // MC CATFER-119
      this.sucursalService.getSucursalById(this.authServices.usuario.ids_sucursales)
        .subscribe((res: any) => {
          if (res.Succeeded) {
            const data = localStorage.getItem('data');
            const authData : UserModel = JSON.parse(data!);
            authData.id_empresa = res.Data.IdEmpresa;
            localStorage.setItem('data', JSON.stringify(authData));
          }
        });
    }

  }

  // MC CATFER-92 Función para obtener el cliente actual
  obtenerCliente(id_cliente) {
    this.clienteService.getCliente(id_cliente).subscribe(resp => {
      this.nombreCliente = resp.Data.Nombre;
    })
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    this.navServices.megaMenu  = false;
    this.navServices.levelMenu = false;
  }

  layoutToggle() {
    this.dark = !this.dark;
    this.layout.config.settings.layout_version = this.dark ? 'dark-only' : 'light';
  }

  searchToggle() {
    this.navServices.search = true;
    this.viewIcon = false;
  }

  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }


}
